;(function () {
  angular.module('contrast.avatar').directive('avatar', [avatar])

  function avatar() {
    return {
      restrict: 'EA',
      templateUrl: 'views/common/avatar.html',
      replace: true,
      controller: 'csAvatarCtrl',
      controllerAs: 'avatarCtrl',
      bindToController: {
        avatar: '=',
        avatarUrl: '='
      }
    }
  }
})()
